import React, { useEffect, useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import _, { split } from "lodash";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import { buttonColors } from "../../../../utils/enum";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import IncrementDecrementTextboxNormal from "../../../../components/common/IncrementDecrementTextbox/IncrementDecrementTextboxNoraml";
import VoidLine from "./VoidLine";
import VoidOut from "./VoidOut";
import CardCommon from "../../../../components/card/CardCommon";
import { convertDateTimeFormat } from "../../../../utils/ConvertDateTimeFormat";

export interface VoidTransactionDetailsModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedData: any;
  userDetails: any;
  locationSelectorList: any;
  isGeneric: any;
  userName: any;
}

function getValidJSONString(input: any) {
  if (typeof input !== "string" || input.trim() === "") return null;

  try {
    const parsed = JSON.parse(input);
    if (
      typeof parsed === "object" &&
      parsed !== null &&
      Object.keys(parsed).length > 0
    ) {
      // It's a valid, non-empty JSON object → do not return
      return null;
    }
  } catch (e) {
    // Not valid JSON → return it (like "abc", "123", etc.)
    return input;
  }

  // It's JSON, but empty or not an object → still return
  return input;
}

const LogDetailsModal: React.FC<VoidTransactionDetailsModalProps> = ({
  isOpen,
  setIsOpen,
  selectedData,
  userDetails,
  locationSelectorList,
  isGeneric,
  userName,
}) => {
  const [voidData, setVoidDate] = useState<any>({});
  const [description, setDescription] = useState<any>("");
  const [kitchenPrintData, setKitchenPrintData] = useState<any>({});
  useEffect(() => {
    if (selectedData?.type === "void") {
      const data = JSON.parse(selectedData?.desc);
      setVoidDate(data);
      setKitchenPrintData({});
      setDescription("");
    } else if (selectedData?.type === "kitchen-print") {
      const data = JSON.parse(selectedData?.desc);
      setKitchenPrintData(data);
      setDescription("");
    } else {
      setDescription(getValidJSONString(selectedData?.desc));
      setKitchenPrintData({});
      setVoidDate({});
    }
  }, [selectedData]);

  // desc
  // :
  // "{\"comments\":\"Void not registered as the basket item is in new state\",\"data\":{\"amount\":\"1.9900\",\"byoMasterSaleItemId\":\"-99\",\"discount\":\"0.0\",\"id\":\"907798fb-5eeb-4285-8519-b61941cbf9da\",\"itemId\":\"1213\",\"itemName\":\" Poppadums\",\"itemType\":\"starters\",\"mealDealStatus\":0,\"qty\":\"1\",\"rewardId\":\"\",\"tableSaleId\":\"0\",\"unitPrice\":\"1.9900\"},\"type\":\"void-line\"}"

  // userId
  // :
  // "41"
  // value
  // :
  // "1.9900"
  return (
    <DialogCommonDefault
      open={isOpen}
      setOpen={setIsOpen}
      isNeedFixedHeight={false}
      backgroundColor="entity_background"
      maxWidth="md"
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px 16px 0 0",
          }}
        >
          <IconButton onClick={() => setIsOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </Grid>
        {selectedData.message && (
          <Grid item xs={12}>
            <div style={{ margin: "28px 28px 0" }}>
              <CardCommon backgroundColor="entity_background">
                <Grid container style={{ padding: "16px" }}>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: 600, marginBottom: 8 }}
                    >
                      Message:
                    </Typography>
                    <Typography>{selectedData.message}</Typography>
                  </Grid>
                  {description && (
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontWeight: 600,
                          marginBottom: 8,
                          marginTop: "12px",
                        }}
                      >
                        Description:
                      </Typography>
                      <Typography style={{ fontSize: "14px" }}>
                        {description}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </CardCommon>
            </div>
          </Grid>
        )}
        <Grid item xs={6}>
          <div
            style={{
              marginLeft: "28px",
              marginRight: "28px",
              marginTop: "28px",
            }}
          >
            <CardCommon backgroundColor={"entity_background"}>
              <Grid container style={{ padding: "16px" }}>
                <Grid item xs={6}>
                  <Typography align="left">User Name</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography align="right">{userName}</Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="left">Date</Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="right">
                    {convertDateTimeFormat(selectedData.date)}
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="left">Device</Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="right">{selectedData.deviceId}</Typography>
                </Grid>
                {selectedData.extQueOrderNo && (
                  <Grid item xs={6} style={{ marginTop: "4px" }}>
                    <Typography align="left">Ext Que Order No</Typography>
                  </Grid>
                )}
                {selectedData.extQueOrderNo && (
                  <Grid item xs={6} style={{ marginTop: "4px" }}>
                    <Typography align="right">
                      {selectedData.extQueOrderNo}
                    </Typography>
                  </Grid>
                )}
                {!isGeneric && (
                  <Grid item xs={6} style={{ marginTop: "4px" }}>
                    <Typography align="left">Order No</Typography>
                  </Grid>
                )}
                {!isGeneric && (
                  <Grid item xs={6} style={{ marginTop: "4px" }}>
                    <Typography align="right">
                      {selectedData.orderNo}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="left">Display Ref</Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="right">
                    {selectedData.queOrderNo}
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="left">Type</Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="right">{selectedData.type}</Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="left">Value</Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "4px" }}>
                  <Typography align="right">{selectedData.value}</Typography>
                </Grid>{" "}
              </Grid>
            </CardCommon>
          </div>
        </Grid>

        {selectedData?.type === "kitchen-print" && kitchenPrintData && (
          <>
            <Grid item xs={6}>
              <div
                style={{
                  marginRight: "28px",
                  marginTop: "28px",
                }}
              >
                <CardCommon backgroundColor={"entity_background"}>
                  <Grid container style={{ padding: "16px", height: "224px" }}>
                    <Grid item xs={6} style={{ marginTop: "24px" }}>
                      <Typography align="left">Print All Order</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: "24px" }}>
                      <Typography align="right">
                        {kitchenPrintData?.printAllOrder?.toString()
                          ? kitchenPrintData?.printAllOrder?.toString()
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: "4px" }}>
                      <Typography align="left">Print Type Only</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: "4px" }}>
                      <Typography align="right">
                        {kitchenPrintData?.isPrintTypeOnly?.toString()
                          ? kitchenPrintData?.isPrintTypeOnly?.toString()
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: "4px" }}>
                      <Typography align="left">Com Type</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: "4px" }}>
                      <Typography align="right">
                        {kitchenPrintData?.compPrintType}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardCommon>
              </div>
            </Grid>
            {kitchenPrintData?.itemLogs?.length > 0 && (
              <Grid
                item
                xs={12}
                style={{
                  marginLeft: "28px",
                  marginRight: "28px",
                  marginTop: "28px",
                }}
              >
                <Grid container>
                  <CardCommon backgroundColor={"entity_background"}>
                    {kitchenPrintData?.itemLogs?.map(
                      (item: any, index: any) => (
                        <Grid
                          container
                          style={{
                            padding:
                              index === 0
                                ? "16px 16px 8px 16px"
                                : "0px 16px 8px 16px",
                          }}
                        >
                          <Grid item xs={12}>
                            <Typography align="left">{item}</Typography>
                          </Grid>
                        </Grid>
                      ),
                    )}
                  </CardCommon>
                </Grid>
              </Grid>
            )}
          </>
        )}
        <Grid item xs={12}>
          {Object.values(voidData).length > 0 &&
            (voidData.type === "void-line" ? (
              <VoidLine
                extraInfo={voidData}
                nodeData={selectedData}
                userList={userDetails}
                locationDetailsList={locationSelectorList}
              />
            ) : (
              <VoidOut
                extraInfo={voidData}
                userList
                nodeData={{
                  ...voidData.data,
                  ...selectedData,
                  comments: voidData?.comments ? voidData.comments : "",
                }}
                locationDetailsList={locationSelectorList}
              />
            ))}
        </Grid>
      </Grid>
      <DialogActions style={{ marginBottom: "12px", marginTop: "12px" }}>
        <ButtonCommon
          onClick={() => setIsOpen(false)}
          variant="contained"
          style={{ fontSize: 11, width: "120px", marginRight: "22px" }}
          color={buttonColors.CANCEL_BUTTON_COLOR}
        >
          Cancel
        </ButtonCommon>
      </DialogActions>
      {/* {Object.values(voidData).length > 0 ? (
        voidData.type === "void-line" ? (
          <VoidLine
            voidData={voidData}
            nodeData={selectedData}
            userList={userList}
            locationDetailsList={locationDetailsList}
          />
        ) : (
          <VoidOut
            voidData={voidData}
            userList
            nodeData={{
              ...voidData.data,
              ...selectedData,
              comments: voidData?.comments ? voidData.comments : "",
            }}
            locationDetailsList={locationDetailsList}
          />
        )
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "20px 0px",
          }}
        >
          <Typography variant="h4">No Void Details Available.</Typography>
        </div>
      )}
      <DialogActions style={{ marginBottom: "12px", marginTop: "12px" }}>
        <ButtonCommon
          onClick={() => setIsOpen(false)}
          variant="contained"
          style={{ fontSize: 11, width: "120px", marginRight: "16px" }}
          color={buttonColors.CANCEL_BUTTON_COLOR}
        >
          Cancel
        </ButtonCommon> */}
      {/* <ButtonCommon
          disabled={stockLevelInitial === stockLevel || isLoadingToast}
          onClick={handleSaveStockLevel}
          variant="contained"
          style={{ fontSize: 11, width: "120px", marginRight: "14px" }}
          color={buttonColors.CREATE_BUTTON_COLOR}
        >
          Done
        </ButtonCommon> */}
      {/* </DialogActions> */}
    </DialogCommonDefault>
  );
};

export default LogDetailsModal;
